module.exports = __webpack_public_path__ + "img/icon_card06.52c53fc6.png";